export function getUser() {
  let user = JSON.parse(localStorage.getItem("user_promo"));
  if (user) {
    return user;
  } else {
    return null;
  }
}
